import { Button, ButtonProps } from '@cmpsr/components';

type CancelRenewalActionProps = ButtonProps & {
  buttonText?: string;
};

export default function CancelRenewalAction({ onClick, buttonText = 'Cancel renewal' }: CancelRenewalActionProps) {
  return (
    <Button
      onClick={onClick}
      size="s"
      variant="link-destroy"
      color="text-error"
      justifyContent="flex-start"
      data-testid="cancel-subscription-button"
    >
      {buttonText}
    </Button>
  );
}
